
import { Component, Vue } from "vue-property-decorator";
import topic from "@/template/topic/topic.vue";
@Component
export default class topiC extends topic {}
